import { render, staticRenderFns } from "./PurchaseCreate.vue?vue&type=template&id=5a31aac5"
import script from "./PurchaseCreate.vue?vue&type=script&lang=js"
export * from "./PurchaseCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports